/**
 * Enum for different arrow types
 */
export enum ArrowType {
  NORMAL = 0,
  FIRE = 1,
  EXPLOSIVE = 2,
  POISON = 3
} 